import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["step", "backButton"]

  initialize() {
    this.showCurrentStep()
  }

  next() {
    this.index++
  }

  previous() {
    this.index--
  }

  reset() {
    this.index = 0
  }

  jumpToSummaryStep() {
    this.index = this.summaryStepIndex
  }

  showCurrentStep() {
    event.preventDefault()
    this.stepTargets.forEach((el, i) => {
      el.classList.toggle("step--current", this.index == i)
      el.scrollTop = 0
    })

    //Temporary: refactor later
    let clientInfoFieldSet = document.getElementById('ba-client-info-fieldset')

    if (this.isClientInfoStep) {
      clientInfoFieldSet.disabled = false
    } else {
      clientInfoFieldSet.disabled = true
    }

    this.prepareBackButton()

    let stepIndicator = document.querySelectorAll('.step-indicator')
    Array.from(stepIndicator).forEach((stepContainer, i) => {
      Array.from(stepContainer.children).forEach((el, i) => {
        if (this.index == i || this.index == 4 && i == 3) {
          el.classList.add('step-indicator__step--active')
        } else {
          el.classList.remove('step-indicator__step--active')
        }
      })
    })
  }

  prepareBackButton() {
    if (this.isFirstStep || this.isSummaryStep) {
      this.backButtonTarget.style.display = 'none'
    } else {
      this.backButtonTarget.style.display = 'block'
    }
  }

  get summaryStepIndex() {
    return this.stepTargets.length -1
  }

  get clientInfoStepIndex() {
    return this.stepTargets.length -2
  }

  get isFirstStep() {
    return this.index === 0
  }

  get isSummaryStep() {
    return this.index === this.summaryStepIndex
  }

  get isClientInfoStep() {
    return this.index === this.clientInfoStepIndex
  }

  get index() {
    return parseInt(this.data.get("index"))
  }

  set index(value) {
    this.data.set("index", value)
    this.showCurrentStep()
  }
}
